<template>
  <div>
    <!-- 入金名义设置 -->
    <el-dialog :title="$t('message.nominalSetting')" :visible.sync="dialogVisible" width="820px" center
      :close-on-click-modal="false">
      <div class="dialog">
        <!-- 列表 -->
        <div class="list" v-for="(item, index) in clientPayAccount.list" :key="index">
          <div class="input">
            <el-input v-model="item.pay_account" type="textarea" :placeholder="$t('message.mingYi')"></el-input>
          </div>
          <div class="item">
            {{ item.created_at }}
          </div>
          <div class="item">
            <!-- 设为默认 -->
            <el-button type="primary" size="mini" v-if="!item.is_default" @click="defaultItem(index)">{{
              $t('message.setAsDefault') }}</el-button>
            <!--  -->
            <el-button type="text" v-else>{{ $t('message.currentDefault') }}</el-button>
          </div>
          <div class="item">
            <el-button type="primary" class="dark" size="mini" @click="del(index)">{{ $t('message.delete') }}</el-button>
          </div>
        </div>
      </div>
      <div class="add">
        <el-button type="success" size="mini" @click="add">{{ $t('message.add') }}</el-button>
      </div>
      <span slot="footer" class="dialog-footer">
        <!-- 取消 -->
        <el-button @click="dialogVisible = false">{{ $t('message.cancel') }}</el-button>
        <!-- 保存 -->
        <el-button type="primary" @click="setClientPayAccount">{{ $t('message.save') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    detail: { type: Object }
  },
  data() {
    return {
      datas: {
        user_id: '',
        realname: '',
        page: 1,
        pageSize: 20,
      },
      dialogVisible: false,
      // 名义
      clientPayAccount: {
        list: [],
        user_id: '',
        bill_method: '',
      },
    };
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.datas.user_id = this.detail.user_id
        this.clientPayAccountList()

      }
    },
  },
  methods: {

    clientPayAccountList() {
      this.$api.financialApi.clientPayAccountList(this.datas).then(res => {
        let list = res.data.data
        let data = {}
        // 查找是否有当前默认名义
        list.forEach(item => {
          item.user_pay_account.forEach(items => {
            let defaultItem = items.list.find(itemss => itemss.is_default == 1)
            if (defaultItem) {
              items.default = defaultItem
            } else {
              items.default = {}
            }
            // 查找银行类型的入金名义列表
            if (items.bill_method == this.detail.bill_method) {
              data = items
            }
          })
        })
        this.nominalSetting(data)
      })
    },
    // 客户-详情-设置客户入金名义
    setClientPayAccount() {
      this.$api.financialApi.setClientPayAccount(this.clientPayAccount).then(res => {
        this.$message.success(res.msg)
        this.dialogVisible = false

      })
    },
    // 名义设置
    nominalSetting(items) {
      this.clientPayAccount = JSON.parse(JSON.stringify(items))
      this.clientPayAccount.user_id = this.detail.user_id

    },
    //新增
    add() {
      this.clientPayAccount.list.push({
        is_default: 0,
        pay_account: '',
      })
    },
    // 删除
    del(i) {
      this.clientPayAccount.list.splice(i, 1)
    },
    //设为默认
    defaultItem(i) {
      this.clientPayAccount.list.forEach(item => {
        item.is_default = 0
      })
      this.clientPayAccount.list[i].is_default = 1
    },

  }
}
</script>
<style lang='scss' scoped>
.search {
  display: flex;

  .item {
    margin-right: 48px;
  }
}

.table {
  margin: 24px 0;

  ol {
    border: 1px solid #ccc;
    position: sticky;
    top: 0;
    left: 0
  }

  li {
    border-right: 1px solid #ccc;

    &:nth-last-child(1) {
      border: 0;
    }
  }

  .content {
    display: flex;
    border: 1px solid #ccc;
    border-top: 0;

    ul {
      padding: 0;
      border-bottom: 1px solid #ccc;

      &:nth-last-child(1) {
        border: 0;
      }

      li {
        padding: 10px 0;
      }
    }

    .item {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      border-right: 1px solid #ccc;
    }

    .list {
      flex: 3;
    }
  }
}

.dialog {
  margin-bottom: 20px;
  max-height: 500px;
  overflow-y: auto;

  .list {
    display: flex;
    border: 1px solid #ccc;
    border-top: 0;

    &:nth-child(1) {
      border-top: 1px solid #ccc;
    }

    .input {
      flex: 2;
      padding: 10px;
    }

    .item {
      padding: 10px;
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      border-left: 1px solid #ccc;
    }
  }
}
</style>